import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const TilesIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M1 4.733V1h3.467v.001h.266v3.732H1Zm.533-.533H4.2V1.533H1.533V4.2Z" />
            <path d="M5.8 1.534v2.664h-.533V1H5.8v.001H9v3.732H5.267V4.2h3.2V1.534H5.8ZM9 5.268H5.267v3.196H5.8V5.801h2.667v2.666h-3.2V9H9V5.268Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M4.467 5.267v.001h.266V9H1V5.267h3.467Zm-2.934 3.2H4.2V5.8H1.533v2.667Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const TilesIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M1 4.733V1h3.467v.001h.266v3.732H1Zm.533-.533H4.2V1.533H1.533V4.2Z" />
            <path d="M5.8 1.534v2.664h-.533V1H5.8v.001H9v3.732H5.267V4.2h3.2V1.534H5.8ZM9 5.268H5.267v3.196H5.8V5.801h2.667v2.666h-3.2V9H9V5.268Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M4.467 5.267v.001h.266V9H1V5.267h3.467Zm-2.934 3.2H4.2V5.8H1.533v2.667Z" />
        </SvgIcon>
    );
};
